import uploadsservicesdmvHearingimageshutterstock_2056433813500x281Jpg from "$lib/data/generated/uploads/services/DMV-Hearing/image/shutterstock_2056433813 500x281.jpg";

export const uploads = {
  "uploads/services/DMV-Hearing/image/shutterstock_2056433813 500x281.jpg": uploadsservicesdmvHearingimageshutterstock_2056433813500x281Jpg
};